
// 採用ページ ヒーロー画像スライダー（連続ループ） // Recruit hero image slider (continuous loop)
if (document.querySelector(".job-swiper")) {
  new Swiper(".job-swiper", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 30,
    speed: 6000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        spaceBetween: 16,
      },
      768: {
        spaceBetween: 30,
      },
    },
  });
}
